<form [formGroup]="form">
    <div class="row answers">
        <mat-radio-group formControlName="borg">
            <mat-radio-button *ngFor="let answer of feedbackAnswers; let i = index" value="{{ answer.id }}" #check class="vertical-radio" id="answer{{ question.id }}{{ i }}" [checked]="this.selectedAnswer && answer.id === this.selectedAnswer['id']" (change)="answerChanged(check.checked ? answer : null, true, answer.data)">{{ answer.label }}</mat-radio-button>
        </mat-radio-group>

        <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="20px" class="mt-20">
            <div fxFlex="50">
                <button mat-stroked-button color="accent" (click)="nextQuestionClicked(true); feedbackQuestionService.backClicked.emit(question)" [disabled]="!hasAnsweredQuestion">
                    <mat-icon>arrow_back</mat-icon>&nbsp;{{ 'Back' | translate }}
                </button>
            </div>

            <div fxFlex="50">
                <button mat-raised-button color="accent" (click)="nextQuestionClicked()" [disabled]="!isNextQuestionEnabled() || isSubmitting">{{ 'Next'|translate }} <mat-icon>arrow_forward</mat-icon></button>
            </div>
        </div>
    </div>
</form>
